export enum BasketballThreePointShotMissedAttribute {
  JumpShot = 659,
}
